import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Modal,
  Table,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';

import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
//import Select from "react-dropdown-select";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../shared/components/form/MultiSelect";
import $ from "jquery";
import readXlsxFile from "read-excel-file";
//import Util from "../../../Common/util";
import XLSX from "xlsx";
import Sheet from "../../../../images/BIN_MASTER_v1.xlsx";
import axios from "axios";
import { MDBDataTable } from "mdbreact";
//import API from "../../../Common/api";
import _ from "lodash";
import "./styles.css";
import LoadingOverlay from "react-loading-overlay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import Alert from "reactstrap/lib/Alert";
import * as FileSaver from 'file-saver';
import exportToCSV from '../../../Common/exportcsv';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import DarkBackground from '../../../Common/backgroundLoader';
import Util from '../../../Common/util';
import API from '../../../Common/api';


const Heading = [['ID','Brand']]
var url = window.location.hostname;
var port = window.location.port;
var data_img = [];
var assign_arr= [];
var unassign_arr = [];
var data_type = "";

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();

    this.toggle = this.toggle.bind(this);
    this.filterData = this.filterData.bind(this);


    this.state = {
      ShowpopupLoader: false,
      showFilter: false,
      ShowConfirmLoader: false,
      isDisabledSearch: false,
      showConfirmError: false,
      arr_data: [],
      showTable: false,
      apply: true,
      showUnAssignedOrder: false,
      showFetchDispatchData: false,
      selectedStation:"",
      disabledBtn: false,
      showData: false,
      showErrorMessage: false,
      showAllItem: false,
      loadingconfirmbtn: false,
      loading: false,
      loading_overlay: false,
      url: window.location.hostname,
      port: window.location.port,
      isChecked: false,
      filtered_brand : "",
      filtered_orderData : [],
    };
  }

  toggle() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }
 

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41"+":8088";
    } else {
      url = window.location.hostname+port;
    }
    
    var cookieUsername = Util.getCookie("token");
    var Location = Util.getCookie("selectedLocation");
    var username = Util.accessCookie("token");
    this.setState(
      {
        userName: cookieUsername,
        selectedLocation: Location,
      },
      () => {
        this.fetchDispatch();
      }
    );
  }





  
   fetchDispatch = (order_no) => {
    this.setState({
      loading_overlay: true,
      loading: true,
    });

         const payload={master_type: "brand"}
        API.post('/jogeshwari/details/v1/', { param: payload })
      .then((response) => response.data)
      .then((data) => {

        this.setState({
          showFetchDispatchData: true,
          loading: false
        });
        
        this.setState({
          orderData: data.data,
          filtered_orderData : data.data,
          tableRowsMap: this.assembleDispatchData(data.data),
          showFetchDispatchData: true,
          dispatch_status: false,
        });

      })

      .catch(function(error) {});
  };


  assembleDispatchData = (dispatchData) => {
    
    let DispatchData = dispatchData.map((post, index) => {
    
      return {
        brand:post.brand,
      };
    });

    this.setState({
      loading_overlay: false,
      loading: false,
    });

    return DispatchData;
  };
  filterData = (evt) => {
    if (evt == ""){
      this.setState ({ filtered_orderData : this.state.orderData})
    }
    else{

    // var brand = this.state.orderData.filter(val => val.brand.toLowerCase().includes(evt.toLowerCase()))
    var value = this.state.orderData.filter(
      (val) =>{
      return Object.keys(val).some(key =>{
        var data = ""
        if (val[key] == null ) {
          data = ""
        } 
        else {
          data = val[key]
        }
        
        return data.toString().toLowerCase().includes(evt.toLowerCase()) 
      })
      }
      );
    
    this.setState({
        filtered_orderData : value
      }) 

  }
  
  }

  render() {

    const dispatchData = {
      columns: [
        {
          label: "Brand",

          field: "brand",
          width: 200,
        },
      ],

      rows: this.state.tableRowsMap,
    };

    return (
      <Col xl={12}>
        
       {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>
           
            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
       

          {this.state.showFetchDispatchData && (
             <div>
            
              
              
        <span
                    className="pull-right"
                    onClick={() => exportToCSV(this.state.filtered_orderData, "Brand Master", Heading)}
                    style={{
                      fontSize: "17px",
                      paddingRight: "0px",
                      cursor: "pointer",
                      color: "#919193",
                      paddingTop: "30px",
                    }}
                  >
                    <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                  </span>

           
    
              
                     
                <MDBDataTable
                  scrollX
                  scrollY
                  maxHeight="390px"
                  onSearch={this.filterData}
                  sortable={false}
                  displayEntries={false}
                  striped
                  bordered
                  data={dispatchData}
                  onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'brand_master_vew', 'datatable_pagination_change' )}
                />
              </div>        

          )}
      </Col>
    );
  }
}



export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));
